import React, { useEffect, useState } from 'react';
import { useMatch, useNavigate, Outlet } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


//Components
import SideNav from '@components/individualPortal/navigation/SideNavigation';

//Containers
import NavBarContainer from '@containers/common/NavBarContainer';
import { brokerNavLinks } from '@containers/individualPortal/navigation/configs/brokerSideNavConfigs';
import { assisterNavLinks } from '@containers/individualPortal/navigation/configs/assisterSideNavConfigs';

//Constants
import { configs } from '@constants/configs/configs';
import { USER_GROUPS, ALL_USER_ROLES } from '@constants/roles/userRoleTypes';


//Utils
import getRoleGroupByRole from '@utils/dashboard/getRoleGroupbyRole';

//Action Creators
import {
    fetchNavBarData,
    fetchLeftNavParams
} from '../actions/actionCreators';


import { setFilterValue } from '@actions/delegation/delegationActionCreators';
import { fetchMockModal } from '@actions/common/actionCreators';
import useForm from '@common-components/form/hooks/useForm';
import { methods } from '@common-components/form/constants/validator';
import { ERROR_MESSAGES } from '../constants/constants';
import { useBroker } from '../../../hooks';



const EDESearchAndSelfDesignationContainer = (props) => {
    const {
        endpoints,
        routes: {
            EDE_SEARCH_PAGE,
            EDE_ID_PROOFING
        }
    } = configs;
    const {
        actions,
        environment: {
            stateCode,
            isState,
            impersonation,
            impersonationDetails,
            user: {
                activeModuleName
            },
            language,
            ticketEnabled,
            isMNFullStack,

        },
        delegation: {
            leftNavParams
        },
        idProofingResponse
    } = props;

    const {  values, handleChange, handleBlur, handleFocus, resetFields, errors, resetErrors, touched, validate } = useForm(
        {},
        {
            attested: undefined,
            documentType: '',
            documentNumber: '',
            method: '',
            searchConsumer: 'ssn',
            ssn: '',
            dob: '',
            firstName: '',
            lastName: '',
            dob_name: '',
            email: '',
            zipCode: '',
            city: ''
        },
        {
            attested: {
                type: 'checked',
                validator: (value)=> !methods.checked([value]),
                errorMsg: ERROR_MESSAGES.ATTEST
            },
            documentType: {
                type: 'notEmpty',
                validator: (value) => !methods.notEmpty([value]),
                errorMsg: ERROR_MESSAGES.DOCUMENT_TYPE
            },
            documentNumber: {
                type: 'validateDocument',
                validator: (value, values) => !methods.validateDocument([values.documentType, value]),
                errorMsg: ERROR_MESSAGES.DOCUMENT_NUMBER
            },
            method: {
                type: 'notEmpty',
                validator: (value) => !methods.notEmpty([value]),
                errorMsg: ERROR_MESSAGES.METHOD
            },
            ssn: {
                type: 'ssn',
                validator: (value)=> !methods.ssn([value]),
                errorMsg: ERROR_MESSAGES.SSN
            },
            dob:[
                {
                    type: 'dateNotGreaterThanCurrentDate',
                    validator: (value)=> !methods.dateNotGreaterThanCurrentDate([value, new Date()]),
                    errorMsg: ERROR_MESSAGES.DOB
                }
            ],

            dob_name: [
                {
                    type: 'dateNotGreaterThanCurrentDate',
                    validator: (value)=> !methods.dateNotGreaterThanCurrentDate([value, new Date()]),
                    errorMsg: ERROR_MESSAGES.DOB
                }
            ],
            firstName: [
                {
                    type: 'name',
                    validator: (value)=> !methods.name([value]),
                    errorMsg: ERROR_MESSAGES.FIRST_NAME
                },
            ],
            lastName: [
                {
                    type: 'name',
                    validator: (value)=> !methods.name([value]),
                    errorMsg: ERROR_MESSAGES.LAST_NAME
                }
            ],
            email: [
                {
                    type: 'email',
                    validator: (value)=> !methods.email([value]),
                    errorMsg: ERROR_MESSAGES.EMAIL
                }
            ],
            zipCode: [
                {
                    type: 'zipCode5Digits',
                    validator: (value)=> !methods.zipCode5Digits([value]),
                    errorMsg: ERROR_MESSAGES.ZIP_CODE
                }
            ],
            city: [
                {
                    type: 'city',
                    validator: (value)=> !methods.onlyLettersAndSplChars([value]),
                    errorMsg: ERROR_MESSAGES.CITY
                }
            ]
        },
        {
            attested: false,
            firstName: false,
            lastName: false,
            dob_name: false,
            documentType: false,
            documentNumber: false,
            method: false,
            ssn: false,
            dob: false,
            email: false,
            zipCode: false,
            city: false
        },
    );
    const role= activeModuleName?.toUpperCase();
    const roleGroup = !impersonation ? getRoleGroupByRole(role) : getRoleGroupByRole(impersonationDetails.role);
    const { isHouseIconVisible } = useBroker();
    const containerWidth = (roleGroup === USER_GROUPS.AGENCY_GROUP || roleGroup === USER_GROUPS.CSR_GROUP) ?
        'grid-col-12' : 'grid-col-9';


    useEffect(() => {
        if ([ALL_USER_ROLES.BROKER, ALL_USER_ROLES.ASSISTER].includes(roleGroup)) {
            actions.fetchLeftNavParams(endpoints.AGENT_LEFT_NAV_PARAMS);
        }
        // Only for CSR group householdCaseId should be pre populated.
        if (roleGroup === USER_GROUPS.CSR_GROUP) {
            const householdCaseId = localStorage.getItem('householdCaseId') || '';
            actions.setFilterValue({ name: 'householdCaseId', value: householdCaseId });
        }

    }, []);

    const match = useMatch(EDE_SEARCH_PAGE);
    
    const navigate = useNavigate();
    
    useEffect(() => {
        if (match && (!idProofingResponse || !idProofingResponse.identityProofId)) {
            navigate(EDE_ID_PROOFING);
        }
    }, []);

    const LeftNav = () => {
        let navLinksByRole = '';
        const { switchAccUrl, encryptedBrokerAssisterId, selfDelegationSwitchAccUrl } = leftNavParams;

        switch (roleGroup) {
            case ALL_USER_ROLES.BROKER:
                navLinksByRole = brokerNavLinks;
                break;
            case ALL_USER_ROLES.ASSISTER:
                navLinksByRole = assisterNavLinks;
                break;
            default:
                break;

        }

        return (
            (roleGroup === ALL_USER_ROLES.BROKER || roleGroup === ALL_USER_ROLES.ASSISTER) &&
            <aside className="usa-layout-docs__sidenav desktop:grid-col-3" id="side-nav">
                {leftNavParams && Object.keys(leftNavParams).length > 0 &&
                <SideNav
                    {...{ stateCode }}
                    navLinks={navLinksByRole}
                    userRole={role}
                    visibilityParams={{ ...leftNavParams, ticketEnabled, isMNFullStack }}
                    replacements={{ switchAccUrl, encryptedBrokerAssisterId, selfDelegationSwitchAccUrl, lang: language === 'en' ? 'en_US' : 'es_ES' }}
                />}
            </aside>);
    };

    const getAllowedUserRolesForNavBar = () => {
        const allowedUserRoles = [
            USER_GROUPS.AGENCY_GROUP,
            ALL_USER_ROLES.BROKER,
            ALL_USER_ROLES.ASSISTER,
            USER_GROUPS.CSR_GROUP
        ];

        return allowedUserRoles;
    };
    //state to maintain Empty Field Error Msg on EDE Search Page
    //This is declared in the parent container as the errors set on the search page
    //has to be cleared on navigating from ID Proofing page
    const [emptyFieldErrMsg, setEmptyFieldErrMsg] = useState(false);
    const [fieldErrors, setFieldErrors] = useState(false);
    const [nonMandatoryFieldErrors, setNonMandatoryFieldErrors] = useState(false);

    return (
        <main className="usa-layout-docs usa-section gi-main-section broker" id="edeSearch">
            <div className="grid-container grid-widescreen gi-grid-container">
                <div className="grid-row grid-gap gi-wrapper">
                    <div className="grid-col-12">
                        <div className="grid-row">
                            <NavBarContainer
                                navBarClass='grid-col-12 menu__top-nav ede-search-top-nav'
                                roleGroup={roleGroup}
                                arrayOfUserRoles={getAllowedUserRolesForNavBar()}
                                houseIcon={isHouseIconVisible}
                            />
                        </div>
                    </div>
                    <div className="grid-col-12">
                        <div className="grid-row grid-gap">
                            <LeftNav />
                            <div className={`usa-layout-docs__main desktop:${containerWidth}`} id="main-content">
                                <Outlet
                                    context={{
                                        values,
                                        handleChange,
                                        handleBlur,
                                        handleFocus,
                                        errors,
                                        resetFields,
                                        resetErrors,
                                        emptyFieldErrMsg,
                                        setEmptyFieldErrMsg,
                                        fieldErrors,
                                        setFieldErrors,
                                        nonMandatoryFieldErrors,
                                        setNonMandatoryFieldErrors,
                                        touched,
                                        validate,
                                    }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );

};

const mapStateToProps = state => ({
    spinner: state.common.spinner,
    environment: state.common.environment,
    delegation: state.delegation,
    idProofingResponse: state.edeSearch.response
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        fetchMockModal,
        fetchNavBarData,
        fetchLeftNavParams,
        setFilterValue
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EDESearchAndSelfDesignationContainer);
